<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 MFP">
     CX833、CX961、CX962、CX963、XC8355、XC9635、XC9645、XC9655 MFP
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ja" title="安全に関する情報">
     安全に関する情報
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="表記規則">
      表記規則
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="製品ステートメント">
      製品ステートメント
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ja" title="プリンタについての確認">
     プリンタについての確認
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ja" title="プリンタに関する情報を見つける">
      プリンタに関する情報を見つける
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ja" title="プリンタのシリアル番号を確認する">
      プリンタのシリアル番号を確認する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ja" title="プリンタ構成">
      プリンタ構成
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ja" title="操作パネルを使用する">
      操作パネルを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_ja" title="ホーム画面のアイコン">
      ホーム画面のアイコン
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_ja" title="インジケータランプの色">
      インジケータランプの色
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ja" title="自動原稿フィーダーと原稿台を使用する">
      自動原稿フィーダーと原稿台を使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ja" title="セキュリティスロットの場所">
      セキュリティスロットの場所
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="用紙を選択する">
      用紙を選択する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10635" title="その他のプリンタ機能とサポート">
      その他のプリンタ機能とサポート
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ja" title="設定、設置、構成">
     設定、設置、構成
    </a>
   </p>
   <div id="divd0e10762">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_ja" title="プリンタの設置場所を選択する">
      プリンタの設置場所を選択する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_ja" title="プリンタポート">
      プリンタポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10961" title="アプリとソリューションを設定する">
      アプリとソリューションを設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11138" title="ユーザー補助機能を設定して使用する">
      ユーザー補助機能を設定して使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11443" title="プリンタを設定して FAX を送信する">
      プリンタを設定して FAX を送信する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_ja" title="用紙と普通紙以外の用紙をセットする">
      用紙と普通紙以外の用紙をセットする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12239" title="ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う">
      ソフトウェア、ドライバ、ファームウェアのインストールと更新を行う
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12565" title="ハードウェアオプションを取り付ける">
      ハードウェアオプションを取り付ける
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14096" title="ネットワーク">
      ネットワーク
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ja" title="プリンタを保護する">
     プリンタを保護する
    </a>
   </p>
   <div id="divd0e14448">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ja" title="プリンタメモリを消去する">
      プリンタメモリを消去する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ja" title="プリンタストレージドライブを消去する">
      プリンタストレージドライブを消去する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ja" title="出荷時初期設定に復元する">
      出荷時初期設定に復元する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ja" title="揮発性に関する記述">
      揮発性に関する記述
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ja" title="印刷">
     印刷
    </a>
   </p>
   <div id="divd0e14640">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_ja" title="コンピュータから印刷する">
      コンピュータから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14691" title="モバイルデバイスから印刷する">
      モバイルデバイスから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ja" title="フラッシュメモリから印刷する">
      フラッシュメモリから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ja" title="コンフィデンシャルジョブを設定する">
      コンフィデンシャルジョブを設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ja" title="コンフィデンシャルジョブおよびその他の保留中のジョブを印刷する">
      コンフィデンシャルジョブおよびその他の保留中のジョブを印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_ja" title="フォントサンプルリストを印刷する">
      フォントサンプルリストを印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_ja" title="ディレクトリ一覧を印刷する">
      ディレクトリ一覧を印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_ja" title="印刷ジョブにセパレータ紙を配置する">
      印刷ジョブにセパレータ紙を配置する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ja" title="印刷ジョブをキャンセルする">
      印刷ジョブをキャンセルする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ja" title="トナーの濃さを調整する">
      トナーの濃さを調整する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ja" title="コピー">
     コピー
    </a>
   </p>
   <div id="divd0e15186">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_ja" title="コピーを作成する">
      コピーを作成する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_ja" title="写真をコピーする">
      写真をコピーする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_ja" title="レターヘッド紙にコピーする">
      レターヘッド紙にコピーする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ja" title="用紙の両面にコピーする">
      用紙の両面にコピーする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_ja" title="コピーを縮小または拡大する">
      コピーを縮小または拡大する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_ja" title="部単位でコピーする">
      部単位でコピーする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ja" title="コピーの区切りとしてセパレータ紙を挿入する">
      コピーの区切りとしてセパレータ紙を挿入する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_ja" title="1 枚の用紙に複数ページをコピーする">
      1 枚の用紙に複数ページをコピーする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_ja" title="カードをコピーする">
      カードをコピーする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ja" title="ショートカットコピーを作成する">
      ショートカットコピーを作成する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_ja" title="E メール">
     E メール
    </a>
   </p>
   <div id="divd0e15459">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_ja" title="SMTP 設定を構成する">
      SMTP 設定を構成する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_ja" title="E メールを送信する">
      E メールを送信する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ja" title="E メールショートカットを作成する">
      E メールショートカットを作成する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ja" title="FAX">
     FAX
    </a>
   </p>
   <div id="divd0e16908">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_ja" title="FAX を送信する">
      FAX を送信する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_ja" title="FAX をスケジュール設定する">
      FAX をスケジュール設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ja" title="FAX 宛先のショートカットを作成する">
      FAX 宛先のショートカットを作成する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ja" title="FAX の解像度変更">
      FAX の解像度変更
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ja" title="FAX の濃度を調整する">
      FAX の濃度を調整する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_ja" title="FAX ログを印刷する">
      FAX ログを印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ja" title="迷惑 FAX をブロックする">
      迷惑 FAX をブロックする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_ja" title="FAX の保留">
      FAX の保留
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_ja" title="FAX の転送">
      FAX の転送
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ja" title="スキャン">
     スキャン
    </a>
   </p>
   <div id="divd0e17204">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ja" title="コンピュータへのスキャン">
      コンピュータへのスキャン
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ja" title="スキャンして FTP サーバーに送信する">
      スキャンして FTP サーバーに送信する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ja" title="FTP ショートカットを作成する">
      FTP ショートカットを作成する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_ja" title="スキャンしてネットワークフォルダに送信する">
      スキャンしてネットワークフォルダに送信する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_ja" title="保存先のネットワークフォルダを設定する">
      保存先のネットワークフォルダを設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ja" title="ネットワークフォルダのショートカットを作成する">
      ネットワークフォルダのショートカットを作成する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ja" title="フラッシュメモリにスキャンする">
      フラッシュメモリにスキャンする
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_ja" title="プリンタメニュー">
     プリンタメニュー
    </a>
   </p>
   <div id="divd0e17493">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_ja" title="メニューマップ">
      メニューマップ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17807" title="デバイス">
      デバイス
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20041" title="印刷">
      印刷
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21323" title="用紙">
      用紙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21655" title="コピー">
      コピー
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22214" title="FAX">
      FAX
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24081" title="E メール">
      E メール
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25178" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25884" title="USB ドライブ">
      USB ドライブ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26730" title="ネットワーク/ポート">
      ネットワーク/ポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28881" title="セキュリティ">
      セキュリティ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29978" title="クラウドサービス">
      クラウドサービス
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30035" title="レポート">
      レポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ja" title="トラブルシューティング">
      <strong>
       トラブルシューティング
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_ja" title="Forms Merge">
      <strong>
       Forms Merge
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_ja" title="［メニュー設定ページ］を印刷する">
      ［
      <strong>
       メニュー設定ページ
      </strong>
      ］を印刷する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_ja" title="プリンタフィニッシャオプション">
     プリンタフィニッシャオプション
    </a>
   </p>
   <div id="divd0e30518">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_ja" title="ホチキスフィニッシャを使用する">
      ホチキスフィニッシャを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_ja" title="ホチキス、穴パンチフィニッシャを使用する">
      ホチキス、穴パンチフィニッシャを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_ja" title="オフセットスタッカを使用する">
      オフセットスタッカを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_ja" title="小冊子フィニッシャを使用する">
      小冊子フィニッシャを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_ja" title="折り畳みオプション付きの用紙搬送ユニットを使用する">
      折り畳みオプション付きの用紙搬送ユニットを使用する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ja" title="プリンタのメンテナンス">
     プリンタのメンテナンス
    </a>
   </p>
   <div id="divd0e30928">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_ja" title="部品と消耗品の状況を確認する">
      部品と消耗品の状況を確認する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ja" title="消耗品通知を設定する">
      消耗品通知を設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_ja" title="E メールアラートを設定する">
      E メールアラートを設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_ja" title="レポートとログを生成する">
      レポートとログを生成する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_ja" title="部品と消耗品を注文する">
      部品と消耗品を注文する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31783" title="部品と消耗品を交換する">
      部品と消耗品を交換する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32407" title="プリンタ部品を清掃する">
      プリンタ部品を清掃する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32571" title="電力と用紙を節約する">
      電力と用紙を節約する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ja" title="プリンタを別の場所に移動する">
      プリンタを別の場所に移動する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ja" title="問題をトラブルシューティングする">
     問題をトラブルシューティングする
    </a>
   </p>
   <div id="divd0e32709">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_ja" title="印刷品質の問題">
      印刷品質の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_ja" title="プリンタのエラーコード">
      プリンタのエラーコード
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_ja" title="印刷の問題">
      印刷の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ja" title="プリンタが応答していない">
      プリンタが応答していない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ja" title="フラッシュメモリを読み取れない">
      フラッシュメモリを読み取れない
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ja" title="USB ポートの有効化">
      USB ポートの有効化
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_ja" title="紙詰まりを取り除く">
      紙詰まりを取り除く
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36133" title="ネットワーク接続の問題">
      ネットワーク接続の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36226" title="ハードウェアオプションの問題">
      ハードウェアオプションの問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36399" title="消耗品の問題">
      消耗品の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36547" title="給紙の問題">
      給紙の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36741" title="E メールの問題">
      E メールの問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36796" title="FAX の問題">
      FAX の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37118" title="スキャンの問題">
      スキャンの問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37536" title="色品質の問題">
      色品質の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ja" title="カスタマサポートに問い合わせる">
      カスタマサポートに問い合わせる
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ja" title="リサイクルおよび廃棄">
     リサイクルおよび廃棄
    </a>
   </p>
   <div id="divd0e37762">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ja" title="Lexmark 製品のリサイクルプログラム">
      Lexmark 製品のリサイクルプログラム
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ja" title="Lexmark 製品の梱包材をリサイクルする">
      Lexmark 製品の梱包材をリサイクルする
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ja" title="通知事項">
     通知事項
    </a>
   </p>
   <div id="divd0e37798">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37801" title="製品情報">
      製品情報
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37818" title="改訂通知">
      改訂通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ja" title="商標">
      商標
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ja" title="ライセンスに関する通知">
      ライセンスに関する通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ja" title="騒音レベル">
      騒音レベル
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37916" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ja" title="製品の廃棄">
      製品の廃棄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ja" title="静電気感知に関する通知">
      静電気感知に関する通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ja" title="国際エネルギースタープログラム（ENERGY STAR）">
      国際エネルギースタープログラム（ENERGY STAR）
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ja" title="温度に関する情報">
      温度に関する情報
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ja" title="レーザーについて">
      レーザーについて
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ja" title="電力消費量">
      電力消費量
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38159" title="ワイヤレス製品に関する規制通知">
      ワイヤレス製品に関する規制通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ja" title="モジュールコンポーネントに関する通知事項">
      モジュールコンポーネントに関する通知事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ja" title="高周波エネルギーの放射に対する被爆">
      高周波エネルギーの放射に対する被爆
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#japanese-vcci-notice_ja" title="日本の VCCI 規定">
      日本の VCCI 規定
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_ja" title="電波障害について">
      電波障害について
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue